(function() {
  'use strict';

  // Modal HTML template
  const modalHTML = `
    <style>
      @import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Source+Sans+Pro:ital,wght@0,400;0,600;0,700;0,900;1,400;1,600;1,700;1,900&display=swap);
      
      truemed-instructions-modal {
        display: none;
        font-family: Source Sans Pro, sans-serif;
        inset: 0;
        margin: 0;
        position: fixed;
        z-index: 1000001;
      }
      
      .truemed-instructions-overlay {
        align-items: center;
        background-color: rgba(52, 52, 52, 0.5);
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
      
      .truemed-instructions-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        max-width: 560px;
        min-height: 80vh;
        width: 100%;
      }
      
      .truemed-instructions-header {
        align-items: stretch;
        background-color: #fff;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-left: 1px solid #edf2f7;
        border-right: 1px solid #edf2f7;
        border-top: 1px solid #edf2f7;
        display: flex;
        flex-direction: row;
        height: 60px;
        justify-content: flex-start;
        margin-top: 10px;
        padding-left: 24px;
        position: relative;
        width: 100%;
      }
      
      .truemed-instructions-header > div {
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      
      .truemed-instructions-close-button {
        background: none;
        border: none;
        cursor: pointer;
        margin: 20px;
        padding: 0;
        position: absolute;
        right: 0;
      }
      
      .truemed-instructions-close-button > div {
        height: 20px;
        width: 20px;
      }
      
      .truemed-instructions-container {
        background: #f7f7f6;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        display: flex;
        flex-direction: column;
        height: 60vh;
        overflow-y: auto;
        width: 100%;
      }
      
      #truemed-instructions-iframe {
        border: 0;
        display: none;
        height: 100%;
        width: 100%;
      }
      
      #spinner-container {
        align-items: center;
        display: flex;
        justify-content: center;
        height: 100%;
      }
      
      .tm-spinner {
        animation: rotate 2s linear infinite;
        height: 50px;
        width: 50px;
      }
      
      .tm-spinner .path {
        stroke: hsla(204, 8%, 76%, 0.9);
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
      }
      
      @keyframes rotate {
        to { transform: rotate(360deg); }
      }
      
      @keyframes dash {
        0% {
          stroke-dasharray: 1, 150;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -35;
        }
        to {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -124;
        }
      }
      
      @media (max-width: 767px) {
        .truemed-instructions-header {
          margin-top: 0;
        }
        .truemed-instructions-box {
          min-height: 100vh;
          min-width: 100vw;
        }
        .truemed-instructions-container {
          height: 100%;
        }
      }
    </style>
    
    <truemed-instructions-modal>
      <div class="truemed-instructions-overlay">
        <div class="truemed-instructions-box">
          <div class="truemed-instructions-header" tabindex="-1">
            <div>
              <img src="https://static.truemed.com/widgets/truemed-navy.svg" 
                   style="width:150px;object-fit:fill" 
                   loading="lazy" 
                   alt="Truemed logo"/>
            </div>
            <button aria-label="Close Truemed modal" class="truemed-instructions-close-button">
              <div>
                <svg aria-hidden="true" focusable="false" role="img" height="20" width="20">
                  <g transform="translate(0, 0) scale(1)">
                    <path d="M10.872 10.004c.449-.14.875-.373 1.23-.729l5.602-5.601L16.29 2.26l-5.602 5.601a.999.999 0 01-1.414 0l-5.57-5.57L2.29 3.705l5.57 5.57c.364.364.8.6 1.261.738a2.86 2.86 0 00-1.229.708L2.29 16.322l1.414 1.414 5.603-5.601a1.022 1.022 0 011.413 0l5.57 5.57 1.414-1.414-5.57-5.57a2.869 2.869 0 00-1.262-.717z" fill="rgba(14, 14, 15, 1)"></path>
                  </g>
                </svg>
              </div>
            </button>
          </div>
          <div id="truemed-instructions-container" class="truemed-instructions-container">
            <div id="spinner-container">
              <svg class="tm-spinner" viewBox="0 0 50 50">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </truemed-instructions-modal>
  `;

  // Simple function to render the widget
  function renderWidget() {
    const container = document.querySelector('#truemed-instructions');
    
    if (!container || container.querySelector('.truemed-entry-box')) {
      return;
    }

    const iconHeight = container.getAttribute('icon-height') || '15';
    const publicId = container.getAttribute('data-public-id');
    const darkMode = container.hasAttribute('dark-mode');
    
    // Set CSS variables based on dark/light mode
    const root = document.querySelector(':root');
    const colors = darkMode ? {
      '--truemed-text-color': '#fff',
      '--truemed-link-color': '#fff',
      '--truemed-link-hover-color': '#179895'
    } : {
      '--truemed-text-color': '#000000bf',
      '--truemed-link-color': '#3c3c3c',
      '--truemed-link-hover-color': '#179895'
    };
    
    Object.keys(colors).forEach(key => {
      root.style.setProperty(key, colors[key]);
    });

    // Create the widget HTML
    const widgetHTML = `
      <style>
        @import url(https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap);
        
        .truemed-entry-box {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          font-family: 'Inter', sans-serif;
          gap: 6px;
          justify-content: center;
          --truemed-icon-height: ${iconHeight}px;
        }

        .truemed-entry-text-container {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 6px;
        }

        .truemed-entry-logo {
          width: 15px;
          height: 15px;
        }

        .truemed-entry-text {
          color: var(--truemed-text-color);
          font-size: 12px;
        }

        .truemed-entry-text-bold {
          font-weight: 700;
        }

        .truemed-entry-link {
          color: var(--truemed-link-color);
          background: none;
          border: none;
          padding: 0;
          margin: 0;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          letter-spacing: 0.02em;
          font-weight: 600;
          text-decoration-line: underline;
        }

        .truemed-entry-link:focus-visible,
        .truemed-entry-link:hover {
          color: var(--truemed-link-hover-color);
        }
      </style>
      
      <div class="truemed-entry-box">
        <div class="truemed-entry-text-container">
          <button type="button" 
                  aria-label="Learn more about Truemed and how to pay with your HSA or FSA for qualified customers" 
                  class="truemed-instructions-open truemed-entry-link">
            Learn more about HSA/FSA eligibility
          </button>
        </div>
      </div>
    `;

    container.innerHTML = widgetHTML;
    
    // Add modal to body if it doesn't exist
    if (!document.querySelector('truemed-instructions-modal')) {
      const modalContainer = document.createElement('div');
      modalContainer.innerHTML = modalHTML;
      document.body.appendChild(modalContainer);
      setupModalHandlers(publicId);
    }
  }

  // Setup modal event handlers
  function setupModalHandlers(publicId) {
    const modal = document.querySelector('truemed-instructions-modal');
    const overlay = document.querySelector('.truemed-instructions-overlay');
    const closeBtn = document.querySelector('.truemed-instructions-close-button');
    const openBtns = document.querySelectorAll('.truemed-instructions-open');
    const instructionsBox = document.querySelector('.truemed-instructions-box');
    
    // Open modal
    function openModal() {
      if (!publicId) {
        console.error('Truemed: data-public-id is required');
        return;
      }
      
      modal.style.display = 'block';
      document.querySelector('html').style.overflow = 'hidden';
      
      // Load iframe if not already loaded
      const iframe = document.querySelector('#truemed-instructions-iframe');
      if (!iframe) {
        const newIframe = document.createElement('iframe');
        newIframe.id = 'truemed-instructions-iframe';
        newIframe.allow = 'fullscreen';
        newIframe.title = 'Truemed Instructions';
        
        const iframeUrl = `https://app.truemed.com/widget/v8/${publicId}?success_action=continue&cart_type=unknown&utm=instructions-widget`;
        newIframe.src = iframeUrl;
        
        newIframe.onload = function() {
          document.querySelector('#spinner-container').style.display = 'none';
          newIframe.style.display = 'block';
        };
        
        document.querySelector('#truemed-instructions-container').appendChild(newIframe);
      }
    }
    
    // Close modal
    function closeModal() {
      modal.style.display = 'none';
      document.querySelector('html').style.overflow = null;
      
      // Reset spinner/iframe state
      const spinner = document.querySelector('#spinner-container');
      const iframe = document.querySelector('#truemed-instructions-iframe');
      if (spinner) spinner.style.display = 'flex';
      if (iframe) iframe.remove();
    }
    
    // Event listeners
    openBtns.forEach(btn => {
      btn.addEventListener('click', openModal);
    });
    
    closeBtn.addEventListener('click', closeModal);
    
    // Close on overlay click (but not when clicking inside the box)
    let clickedInside = false;
    
    instructionsBox.addEventListener('mousedown', () => {
      clickedInside = true;
    });
    
    overlay.addEventListener('mousedown', () => {
      clickedInside = false;
    });
    
    overlay.addEventListener('click', (e) => {
      if (!clickedInside && e.target === overlay) {
        closeModal();
      }
    });
    
    // Listen for messages from iframe
    window.addEventListener('message', (event) => {
      const { type } = event.data || {};
      
      if (type === 'CONTINUE_SHOPPING' || type === 'CHECKOUT_WITH_TM') {
        closeModal();
      }
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderWidget);
  } else {
    renderWidget();
  }

  // Optional: Watch for dynamic content changes
  const observer = new MutationObserver(renderWidget);
  observer.observe(document.body, { childList: true, subtree: true });

})();